// Number of SQPR periods to show on the quality page
export const NUM_SQPR_PERIODS = 14;
